import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { checkoutAdminAccessControl } from '../access-control/checkoutAdminAccess.configuration'

const CheckoutDigitalGiftCardUploadPage = lazy(
  () => import('../pages/digital-gift-card-upload/CheckoutDigitalGiftCardUploadPage')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const checkoutAdminRouter = (
  <DomainRoute route="app-admin-checkout" accessControl={checkoutAdminAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-checkout-digital-gift-card-upload"
        component={CheckoutDigitalGiftCardUploadPage}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
